import type { FlattenedItem } from './entities';

export type HeaderEntry = { item: FlattenedItem; index: number };

/**
 * Determines which header to pin in the sticky toolbar based on scroll direction
 * and the last header that crossed the observation boundary.
 *
 * Scrolling down: pin the header that just entered the top zone.
 * Scrolling up:   pin the header *before* the one that just crossed back,
 *                 because that is the section the user is re-entering.
 *                 Returns null when above the very first header.
 */
export function resolvePinnedHeader(
  headers: HeaderEntry[],
  lastSelectedHeader: FlattenedItem | null,
  scrollDirection: 'up' | 'down',
): FlattenedItem | null {
  if (!lastSelectedHeader) return null;

  if (scrollDirection === 'down') {
    return lastSelectedHeader;
  }

  const idx = headers.findIndex((h) => h.item.id === lastSelectedHeader.id);
  if (idx <= 0) return null; // not found, or already at the first header
  return headers[idx - 1].item;
}
